<script>
import { Doughnut } from 'vue-chartjs'

export default {
  extends: Doughnut,
  props: ['userAccessByGenderAndAge'],
  mounted() {
    this.options = {
      legend: {
        position: "bottom"
      },
      tooltips: {
        enabled: true
      },
      plugins: {
        datalabels: {
          display: true,
          color: '#FFF',
          font: function(context) {
            return {
              size: 12
            }
          }
        }
      }
    }
    this.render()
  },
  computed: {
    chartData() {
      return {
        labels: this.makeLabels,
        datasets: [{
          data: this.countsByGender,
          backgroundColor: this.makeBackground,
          borderWidth: 0,
          hoverBackgroundColor: this.makeHoverBackground
        }]
      }
    },
    countsByGender() {
      const result = [ ];
      if (this.checkEmpty()){
        result.push(1);
      } else {
        for (let g of ['male', 'female', 'other']) {
          let count = Object.values(this.userAccessByGenderAndAge[g]||{}).reduce((a,v)=>a+=v,0);
          if (g === 'other') {
              count += Object.values(this.userAccessByGenderAndAge['_unknown']||{}).reduce((a,v)=>a+=v,0);
          }
          result.push(count);
        }
      }
      return result;
    },
    makeLabels() {
      return (this.checkEmpty()) ? [this.$t('Analysis.User.none')] : [this.$t('Analysis.User.male'),this.$t('Analysis.User.female'),this.$t('Analysis.User.other')]
    },
    makeBackground() {
      return (this.checkEmpty()) ? ['#EEE'] : ['#009CE1','#99D7F3','#DDDDDD']
    },
    makeHoverBackground() {
      return (this.checkEmpty()) ? ['#EEE'] : []
    }
  },
  methods: {
    checkEmpty: function()
    {
      return Object.values(this.userAccessByGenderAndAge).every(v => Object.keys(v).length === 0)
    },
    render : function()
    {
      let d = this.chartData.datasets
      let o = this.options
      let colors = ['#009CE1','#99D7F3','#DDDDDD']

      d.hoverBackgroundColor = colors
      d.backgroundColor = colors
      d.borderWidth = 1
      o.plugins.datalabels.display = true
      o.tooltips.enabled = true

      if (this.checkEmpty()){
        d.hoverBackgroundColor = ['#EEE']
        d.backgroundColor = ['#EEE']
        d.borderWidth = 0
        o.plugins.datalabels.display = false
        o.tooltips.enabled = false
      }
      this.renderChart(this.chartData, this.options)
    }
  },
  watch: {
    userAccessByGenderAndAge() {
      this.render()
    }
  }
}
</script>

